// extracted by mini-css-extract-plugin
module.exports = {"changePhone":"changePhone_changePhone__psAuy","text":"changePhone_text__L1P9N"};